import * as actions from "./actionsTypes";

const initialData = {
  loaderMantIndk: false,
  loaderMantIndks: false,
  saveLoaderMantIndk: false,
  mantIndks: null,
  mantIndk: null,
  mantIndksFail: null,
  mantIndkFail: null,
  formMantIndkFail: null  
};

export default function MantIndkReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_MANT_INDK:
      return { ...state, loaderMantIndk: action.payload};
    case actions.LOADER_MANT_INDKS:
      return { ...state, loaderMantIndks: action.payload};
    case actions.SAVE_LOADER_MANT_INDK:
      return { ...state, saveLoaderMantIndk: action.payload};
    case actions.GET_MANT_INDK:
      return { ...state, mantIndk: action.payload};
    case actions.GET_MANT_INDKS:
      return { ...state, mantIndks: action.payload};
    case actions.MANT_INDK_FAIL:
      return { ...state, mantIndkFail: action.payload}
    case actions.MANT_INDK_FAILS:
      return { ...state, mantIndksFail: action.payload};
    case actions.FORM_MANT_INDK_FAIL:
      return { ...state, formMantIndkFail: action.payload};
    default:
      return state;
  }
}
